import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const RackListPageRBAC = {
  pageID: '80f201af7fdc5d85831d0949a0be5b70',
  elementID: {
    BtnAddRack: '3edeeea248abe7a1278c99ca019a9a14',
    BtnExportCSV: '7a147cacc4e60e2c110ea6b99dd064ea',
    BtnViewDetail: '92c64bba59130eeb746f8b30848f2808',
  },
} as const

export const useRBACRackListPage = createUseRBAC(RackListPageRBAC.elementID)

export type UseRBACRackListPageType = ReturnType<typeof useRBACRackListPage>
